import { Button } from '../components/Button';
import { Cross } from '../components/icons/Cross';
export const getSchoolcon = (
  school_level: 'Primary' | 'Secondary' | 'Sec/Prim' | 'Special'
) => {
  switch (school_level) {
    default:
    case 'Primary':
      return (
        <Button circle colour='cyan' className='h-6 w-6'>
          <Cross variant='dark' className='w-3/4' />
        </Button>
      );
    case 'Secondary':
      return (
        <Button circle colour='bluestone' className='h-6 w-6'>
          <Cross variant='light' className='w-3/4' />
        </Button>
      );
    case 'Sec/Prim':
      return (
        <Button circle colour='golden' className='h-6 w-6'>
          <Cross variant='dark' className='w-3/4' />
        </Button>
      );
    case 'Special':
      return (
        <Button circle colour='teal' className='h-6 w-6'>
          <Cross variant='light' className='w-3/4' />
        </Button>
      );
  }
};
